import {
  Box,
  Container,
  Flex,
  Heading,
  Image,
  List,
  ListItem,
  Text,
} from "@chakra-ui/react";
import React from "react";

const Swap = ({ title, desc, points, image, swap }) => {
  return (
    <Box mt={{ md: 48, base: 24 }}>
      <Container maxW={{ md: "80%", base: "100%" }}>
        <Flex
          gap={16}
          flexDir={
            swap
              ? { lg: "row-reverse", base: "column" }
              : { lg: "row", base: "column" }
          }
        >
          <Box w={{ lg: "50%", base: "100%" }}>
            <Heading
              mb={12}
              color={"DarkBlue"}
              fontSize={{ md: "6xl", base: "4xl" }}
            >
              {title}
            </Heading>
            <Text mb={8} color={"DarkBlue"}>
              {desc}
            </Text>
            <List spacing={4}>
              {points?.map((item) => {
                return (
                  <ListItem color={"DarkBlue"} key={item?.id}>
                    {item?.text}
                  </ListItem>
                );
              })}
            </List>
          </Box>
          <Box mt={12} w={{ lg: "50%", base: "100%" }}>
            <Image src={image} />
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};

export default Swap;
